import { Fragment, useState } from 'react';
import Dashboard from '../Admin/Dashboard/Dashboard';
import CurrentDate from '../Admin/CurrentDate';
import { Link } from 'react-router-dom';
import Loader from '../Admin/Dashboard/Loader';
import axios from 'axios';
import baseApi from '../api';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import '../../index.css';

const AddCaseStudyCategory = (props) => {
  const [isLoading, setIsloading] = useState(false);
  const [preview, setPreview] = useState();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      page_title: '',
      page_description: '',
      case_study_category: ''
    },
    validationSchema: Yup.object({
      page_title: Yup.string().required('Please enter page title'),
      page_description: Yup.string().required('Please enter page description'),
      case_study_category: Yup.string().required('Please enter case study category')
    }),
    onSubmit: (values) => {
      setIsloading(true);
      const formData = new FormData();
      formData.append('page_title', values.page_title);
      formData.append('page_description', values.page_description);
      formData.append('case_study_category', values.case_study_category);

      axios
        .post(
          `${baseApi}case-study/add-case-study-category`,
          {
            case_study_category: values.case_study_category,
            page_description: values.page_description,
            page_title: values.page_title
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('jwtToken')}`
            }
          }
        )
        .then((res) => {
          setIsloading(false);
          setPreview('');
          formik.resetForm();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  });

  return (
    <Fragment>
      <div className="admin_panel">
        <Dashboard />

        {!isLoading ? (
          <div className="container">
            <div className="col-sm-12">
              {' '}
              <CurrentDate />
              <form onSubmit={formik.handleSubmit} encType="application/json">
                <div className="form-group">
                  <label>
                    <h3>Case Study Category</h3>
                  </label>
                  <input type="text" className="form-control" id="case_study_category" name="case_study_category" {...formik.getFieldProps('case_study_category')} />

                  <span className="text-danger">{formik.touched.case_study_category && formik.errors.case_study_category ? <div>{formik.errors.case_study_category}</div> : null}</span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Page Title</h3>
                  </label>
                  <input type="text" className="form-control" id="page_title" name="page_title" {...formik.getFieldProps('page_title')} />

                  <span className="text-danger">{formik.touched.page_title && formik.errors.page_title ? <div>{formik.errors.page_title}</div> : null}</span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Page Description</h3>
                  </label>
                  <input type="text" className="form-control" id="page_description" name="page_description" {...formik.getFieldProps('page_description')} />

                  <span className="text-danger">{formik.touched.page_description && formik.errors.page_description ? <div>{formik.errors.page_description}</div> : null}</span>
                </div>

                <hr />

                <div className="form-group">
                  <input type="submit" className="btn btn-primary" value="Add CS Category" />
                  &nbsp;&nbsp;
                  <Link to="/case-study-category">Back to CS Category</Link>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </Fragment>
  );
};

export default AddCaseStudyCategory;
